import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';


@Component({
  selector: 'app-table-dedicated-ip-batchlist',
  templateUrl: './table-dedicated-ip-batchlist.component.html',
  styleUrls: ['./table-dedicated-ip-batchlist.component.scss']
})
export class TableDedicatedIpBatchlistComponent implements ViewCell, OnInit {

  @Input() rowData: any;
  @Input() value: string | number;

  statusText: string;
  statusClass: string;
  
  constructor() { }

  ngOnInit() {

    this.statusText = '';
    for( let i=0; i < this.rowData.ip.length; i++ ){
      this.statusText += this.rowData.ip[i] + '\n'; 
    }
  }

}
